import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';

import { SkySortService } from './sort.service';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { Subscription } from 'rxjs/Subscription';

const SORT_ITEM_ID_PREFIX = 'sky-sort-item-';
let sortItemIdNumber: number = 0;


export class SkySortItemComponent implements OnInit, OnChanges, OnDestroy {
  
  public active: boolean;

  
  public itemSelect: EventEmitter<any> = new EventEmitter();

  public isSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private subscription: Subscription;

  private sortItemId: string;

  constructor(private sortService: SkySortService, private detector: ChangeDetectorRef) {}

  public ngOnInit() {

    sortItemIdNumber++;
    this.sortItemId = SORT_ITEM_ID_PREFIX + sortItemIdNumber.toString();
    this.subscription = this.sortService.selectedItem.subscribe((itemId: string) => {
      this.isSelected.next(itemId === this.sortItemId);
      this.detector.detectChanges();
    });

    if (this.active) {
      this.sortService.selectItem(this.sortItemId);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['active']
      && changes['active'].currentValue
      && changes['active'].currentValue !== changes['active'].previousValue) {
      this.sortService.selectItem(this.sortItemId);
    }
  }

  public itemClicked() {
    this.sortService.selectItem(this.sortItemId);
    this.itemSelect.emit();
  }

  public ngOnDestroy() {
    /* istanbul ignore else */
    /* sanity check */
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-sort-item',
  styles: [`.sky-sort-item{background-color:transparent;border:none;display:block;margin:4px;min-width:160px;text-align:left;transition:background-color 150ms}.sky-sort-item:hover{background-color:#eeeeef}.sky-sort-item /deep/>button{background-color:transparent;border:none;cursor:pointer;display:block;padding:3px 20px;text-align:left;width:100%}.sky-sort-item-selected{background-color:#f1eef6;padding:4px;margin:0}
`],
  template: `<div
    class="sky-sort-item"
    [ngClass]="{'sky-sort-item-selected': (isSelected | async)}">
    <button
      type="button"
      [ngClass]="{'sky-emphasized': (isSelected | async)}"
      (click)="itemClicked()">
        <ng-content></ng-content>
    </button>
</div>
`,
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkySortService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'active': [{ type: Input },],
'itemSelect': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
